import Styles from "./index.module.scss"

const ContentTypeFilter = ({
  items = [],
  handleSelectedContentType = () => {},
  selectedContentType = null,
}) => {
  return (
    <div className={Styles.searchFiltersContent}>
      <div className="filter-group-category">
        <h3 className="filter-group-title">Content Type</h3>
        {selectedContentType ? (
          <ul className="selected-filters-videoart">
            <li>
              <button className="selected-filter cursor-pointer">
                <span className="name">{selectedContentType?.value}</span>
                <span className="count text-[#999999] ml-[5px]">
                  ({selectedContentType?.count})
                </span>
              </button>
            </li>
          </ul>
        ) : null}
        <ul className="available-filters-videoart flex flex-col">
          {items.map((item, index) => (
            <li key={index}>
              <button
                className="cursor-pointer"
                onClick={() => handleSelectedContentType(item)}
              >
                <span className="name">{item.value}</span>
                <span className="count ml-[5px]">({item.count})</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ContentTypeFilter
